import { render, staticRenderFns } from "./ExportPerformance.vue?vue&type=template&id=86e4fc46&"
import script from "./ExportPerformance.vue?vue&type=script&lang=js&"
export * from "./ExportPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports